import React, { memo, useCallback, useContext } from 'react';
import { View, StyleSheet, } from 'react-native';
import { CardView, rem } from 'design-system';
import RowTransaction from 'features/transactions/components/RowTransaction';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import SwitchingButton from 'features/subscriptions/components/row/SwitchingButton';
import { Amplitude } from 'utils';
import useNavigateTransactionItem from 'features/transactions/hooks/useNavigateTransactionItem';
import Section from '../Section';
import { isWeb } from '../../../../constants';
import TransactionsSeeAllButton from './TransactionsSeeAllButton';
import { WalkthroughContext } from '../walkthrough/context';
const strings = {
    title: 'Transactions',
};
const Transactions = ({ data, style, onLayout }) => {
    const navigation = useMainStackNavigation();
    const { paddingHorizontalStyle } = useAppFrameDimensions(true);
    const navigateToTransactionItem = useNavigateTransactionItem();
    const guessedHomeCountry = useAppSelector((store) => store.user.user.guessedHomeCountry);
    const onCompare = useCallback((routeWithParams) => {
        navigation.navigateDeprecated(routeWithParams);
        Amplitude.logEvent('Transactions.openCompare', {
            type: routeWithParams.name,
        });
    }, []);
    const isInWalkthrough = useContext(WalkthroughContext);
    const onTransactionPressed = useCallback((data) => {
        navigateToTransactionItem(data);
    }, [navigateToTransactionItem]);
    if (!data.length) {
        return null;
    }
    return (<Section title={strings.title} button={<TransactionsSeeAllButton />} onLayout={onLayout} withFrame={false} titleContainerStyle={isInWalkthrough ? styles.walkthroughSectionTitleStyles : undefined} style={isInWalkthrough ? styles.walkthroughSectionStyles : undefined}>
      <View style={[style, !isInWalkthrough && paddingHorizontalStyle]}>
        <CardView noMarginTop noMarginBottom webPadding={isWeb} noMargin={isInWalkthrough}>
          {data.map((txn) => (<RowTransaction key={txn.id} item={txn} backgroundDark showUpgradeButton switchingButon={<SwitchingButton data={txn && txn.merchant ? { merchantInfo: txn.merchant } : null} guessedHomeCountry={guessedHomeCountry} onOpenCompare={onCompare}/>} onPress={() => onTransactionPressed(txn)}/>))}
        </CardView>
      </View>
    </Section>);
};
const styles = StyleSheet.create({
    walkthroughSectionTitleStyles: {
        marginHorizontal: rem(4),
    },
    walkthroughSectionStyles: {
        marginBottom: 0,
    },
});
export default memo(Transactions);
